module.exports = __webpack_public_path__ + "img/Liputan-Image.cc0fbe28.png";